import { render, staticRenderFns } from "./single-sort.vue?vue&type=template&id=3b329bb5&scoped=true&"
import script from "./single-sort.vue?vue&type=script&lang=js&"
export * from "./single-sort.vue?vue&type=script&lang=js&"
import style0 from "./single-sort.vue?vue&type=style&index=0&id=3b329bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b329bb5",
  null
  
)

export default component.exports